import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminLayout from "../../admin/AdminLayout";
import AdminAuthGuard from "../../admin/AdminAuthGuard";
import { api } from "../../api/client";
import { TestTube, ChevronRight } from "lucide-react";

const STATUS_TONES = {
    pending_payment: "bg-amber-100 text-amber-800",
    confirmed: "bg-blue-100 text-blue-700",
    sample_collected: "bg-violet-100 text-violet-700",
    processing: "bg-violet-100 text-violet-700",
    report_ready: "bg-emerald-100 text-emerald-700",
    cancelled: "bg-zinc-100 text-zinc-700",
};
const TABS = ["all", "confirmed", "sample_collected", "processing", "report_ready", "cancelled"];

const inr = (v) => `₹${Number(v || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;

const AdminLabOrders = () => {
    const [tab, setTab] = useState("confirmed");
    const [items, setItems] = useState([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(true);

    const load = () => {
        setLoading(true);
        const params = new URLSearchParams();
        if (tab !== "all") params.set("status", tab);
        api.get(`/admin/lab-orders?${params.toString()}`).then((r) => {
            setItems(r.data.items || []);
            setTotal(r.data.total || 0);
        }).finally(() => setLoading(false));
    };
    useEffect(load, [tab]); // eslint-disable-line

    return (
        <AdminAuthGuard>
            <AdminLayout title="Lab orders" subtitle={`${total} order(s) in this view`}>
                <div className="mb-4 flex flex-wrap gap-1.5" data-testid="admin-labs-tabs">
                    {TABS.map((s) => (
                        <button
                            key={s}
                            onClick={() => setTab(s)}
                            className={`rounded-full px-3 py-1 text-xs font-medium transition-colors ${tab === s ? "bg-brand-700 text-white" : "border border-zinc-200 bg-white text-zinc-700 hover:bg-zinc-50 dark:bg-white/5 dark:text-zinc-300"}`}
                            data-testid={`admin-labs-tab-${s}`}
                        >
                            {s.replace("_", " ")}
                        </button>
                    ))}
                </div>

                {loading ? (
                    <p className="text-sm text-zinc-500">Loading…</p>
                ) : items.length === 0 ? (
                    <p className="rounded-2xl border border-dashed border-zinc-200 p-8 text-center text-sm text-zinc-500">No lab orders in this view.</p>
                ) : (
                    <ul className="space-y-2" data-testid="admin-labs-list">
                        {items.map((l) => (
                            <li key={l.id}>
                                <Link
                                    to={`/admin/lab-orders/${l.id}`}
                                    className="flex items-center justify-between gap-3 rounded-2xl border border-zinc-100 bg-white p-4 transition-colors hover:border-brand-200 dark:bg-white/[0.03]"
                                    data-testid={`admin-lab-row-${l.id}`}
                                >
                                    <TestTube className="h-4 w-4 text-brand-700" />
                                    <div className="min-w-0 flex-1">
                                        <p className="text-sm font-medium text-zinc-900 dark:text-zinc-50">{l.lab_no} <span className="text-xs text-zinc-500">· {inr(l.total)}</span></p>
                                        <p className="mt-0.5 text-xs text-zinc-500 line-clamp-1">{l.user_name || l.user_email || "Patient"} · {(l.items || []).length} item(s) · {new Date(l.created_at).toLocaleString()}</p>
                                    </div>
                                    <span className={`whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-medium ${STATUS_TONES[l.status] || "bg-zinc-100 text-zinc-700"}`}>{(l.status || "").replace("_", " ")}</span>
                                    <ChevronRight className="h-4 w-4 text-zinc-400" />
                                </Link>
                            </li>
                        ))}
                    </ul>
                )}
            </AdminLayout>
        </AdminAuthGuard>
    );
};

export default AdminLabOrders;
